// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace typeUtil {
    export type CallbackFunction = () => void;
    export type InitFunction = () => void;
    export type StringOrUndefined = string | undefined;
    export type NumberOrUndefined = number | undefined;

    export interface IObjectIndexer<T> {
        [key: string]: T;
    }

    export class ObjectIndexer<T> implements IObjectIndexer<T> {
        [key: string]: T;
    }
}






